import {Provider} from './provider';
import {Config} from '../config';
import {PaymentType} from './payment-type';
import {Logger} from '../logger';
import { ErrorView } from '../view/error-view';
import { ErrorType } from '../config/error-type';

declare const process: any;

export class DepositfixProvider extends Provider {

    constructor() {
        super();
    }

    errorView: ErrorView = new ErrorView();
    logger: Logger = {} as Logger;

    submitStripe(config: Config, data: any) {
        return this.submit(`${config.host}payments/order/${config.portalId}`, data);
    }

    submitPaypal(config: Config, data: any) {
        return this.submit(`${config.host}payments/order/${config.portalId}`, data);
    }

    submitOfflinePayment = (config: Config, data: any) => {
        return this.submit(`${config.host}payments/order/${config.portalId}`, data);
    }

    submitWidget(config: Config, data: any, type: PaymentType): Promise<any> {
        switch (type) {
            case PaymentType.STRIPE:
                return this.submitStripe(config, data);
            case PaymentType.STRIPE_GOOGLE_PAY:
                return this.submitStripe(config, data);
            case PaymentType.STRIPE_APPLE_PAY:
                return this.submitStripe(config, data);
            case PaymentType.STRIPE_ACH:
                return this.submitStripe(config, data);
                case PaymentType.STRIPE_BACS:
                    return this.submitStripe(config, data);
            case PaymentType.PAYPAL:
                return this.submitPaypal(config, data);
            case PaymentType.OFFLINE:
                return this.submitOfflinePayment(config, data);
            default:
                return Promise.reject('Unsupported payment type');
        }
    }

    getConfig(config: Config, isForcedTestMode: boolean) {
        const host = process.env.API_URL;
        let url = `${host}pub/forms?form=${config.formId}&portal=${config.portalId}`;
        if (isForcedTestMode) {
            url += `&mode=test`;
        }
        return this.fetch(url)
            .then(response => Promise.resolve(response))
            .catch(async (err: any) => {
                let error: any = {};
                this.logger = new Logger({});
                try {
                    error = await err.json();
                    this.logger.log(error.message);
                } catch (e) {
                    error.message = 'DepositFix fetch error';
                    this.logger.log(error);
                }
                await this.errorView.render(ErrorType.SERVER_NOT_AVAILABLE, error);
            });
    }

    sendPageEvent(config: Config) {
        const data = {
            'ip_address': config.session ? config.session.ip : '',
            'country_code': config.session ? config.session.country_code : '',
            'form_id': config.formId,
            'url': document.location? document.location.href : '',
            'browser': navigator.userAgent
        };

        const host = process.env.API_URL;
        return this.submit(`${host}pub/events/${config.user.portalId}/page_visit`, data);
    }
}
